import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";
import _ from "lodash";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useGeodataColumns } from "@/pages/geodata/hooks/use-columns";
import { IGeodataData } from "@/types/geodata";

export const GeodataList = () => {
  const columns = useGeodataColumns();

  const defaultQueryBy = "name";

  const table = useTable<IGeodataData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: {
        right: ["actions"],
      },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
        // facetReturnParent: ["geodata.name"],
      },
      sorters: {
        initial: [
          {
            field: "createdAt",
            order: "desc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
    meta: {
      querySuggestions: [
        {
          id: "type",
          label: "type",
        },
        {
          id: "country",
          label: "country",
        },
      ],
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="geodata" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
